import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementCompareType extends StoryElementBase {
	type = StoryElementType.COMPARE_TYPE;

	override get isLoading(): boolean {
		return super.isLoading || !this.compare;
	}

	get longTitle(): string {
		let text = 'Comparison period';

		const compare = this.compare;
		if (compare?.isGoal) {
			text = 'Comparison goal';
		} else if (compare?.isOtherMetric) {
			text = 'Comparison metric';
		}

		return text;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		let text = '';

		const compare = this.compare;
		if (compare) {
			if (compare.isOtherMetric) {
				const compareMetricData = this.compareMetricData;
				if (compareMetricData) {
					this.addLayoutForSourceAndMetric(node, compareMetricData);
					return;
				}
			} else {
				text = compare.titleUX;
			}
		} else {
			text = '<unknown>';
		}

		node.textContent = text;
	}
}
